//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import helpers from "~/mixins/helpers.js";
import { clarityEvent } from "~/services/util";
import generateID from "@/mixins/generateID";
import FormField from "@/models/FormField";
import differenceInDays from "date-fns/differenceInDays";
import format from "date-fns/format";
import getYear from "date-fns/getYear";

import {
  TEXT_INPUT,
  CHECKBOX,
  SELECT_FIELDS,
  YES_NO,
  DATE_PICKER,
} from "@/models/FormField";
import {
  states,
  stateNameByValue,
  stateValueByAbbreviation,
  stateNameByAbbreviation,
} from "~/src/states.js";

export default {
  mixins: [helpers, generateID],

  props: {
    companyName: {
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      page: "start",
      formData: {
        formed: null,
        boir: null,
        cg: false,
        ra: false,
        logo: false,
        ein: false,
        website: false,
        banking: false,
        insurance: false,
      },
      submission: {
        state_id: null,
        entity_type: "LLC",
        name: this.companyName,
        formed: "",
        formation_date: null,
      },
    };
  },

  methods: {
    goToPartner(link, partner_name, place, external) {
      clarityEvent("Checklist Click", {
        type: partner_name,
        place: place,
      });
      if (external) window.open(link, "_blank");
      else this.$router.push(link);
    },
    updateData(newValue) {
      this.submission = newValue;
    },
    nextPage() {
      this.$store
        .$db()
        .model("Company")
        .createCompany(this.submission);

      this.page = "boir";
    },
  },
  computed: {
    boirDate() {
      if (this.submission.formation_date) {
        if (new Date(this.submission.formation_date).getFullYear() >= 2024) {
          let currentDate = new Date();
          let daysPassed = differenceInDays(
            currentDate,
            new Date(this.submission.formation_date)
          );
          let daysleft = 90 - daysPassed;
          return `The deadline for filing a BOIR for ${this.submission.name} is approaching, you have ${daysleft} days left to file. File before your federal deadline so you can avoid a penalty of $500/day.`;
        } else
          return "You need to file an initial BOIR until the end of the year. File before your federal deadline so you can avoid a penalty of $500/day.";
      }
    },
    fields() {
      let data = [
        new FormField({
          field_type: "state_select",
          name: "state_id",
          label: "State",
          options: states,
          width: 6,
          validation: { required: true },
          disabled: false,
        }),
        new FormField({
          field_type: "select",
          name: "entity_type",
          label: "Entity",
          options: [
            { value: "LLC", label: "LLC" },
            { value: "C Corp", label: "C Corp" },
            { value: "S Corp", label: "S Corp" },
            { value: "Nonprofit", label: "Nonprofit" },
          ],
          width: 6,
          validation: { required: true },
          disabled: false,
        }),
        new FormField({
          field_type: DATE_PICKER,
          name: "formation_date",
          label: "Formation Date",
          isWrittenDate: true,
          meta: { format: "YYYY-M-D", type: "date", range: [2000, 2024] },
          width: 12,
          required: true,
        }),
      ];
      if (!this.companyName)
        data.push(
          new FormField({
            field_type: TEXT_INPUT,
            name: "name",
            label: "Company Name",
            placeholder: "E.g. eDemand LLC",
            width: 12,
            validation: { required: true },
            disabled: false,
          })
        );

      return data;
    },
    visibleChecklist() {
      return this.checklist.filter((item) => item.visible);
    },
    checklist() {
      return [
        {
          headline: "File your BOIR report",
          description: `The deadline for filing a BOIR for Acme LL is ${this.boirDate}.`,
          visible: this.formData.boir === false,
          cta1: {
            link: "/orders/create/beneficial-ownership-information-report",
            text: "",
            direct: true,
            type: "transparent-blue",
          },
        },
        {
          headline: "Get a Registered Agent",
          description:
            "A registered agent is the person or entity designated by a business to receive legal and government correspondence.",
          visible: this.formData.ra === false,
          cta1: {
            link: "/orders/create/registered-agent",
            text: "Get Started",
            direct: true,
            type: "transparent-blue",
          },
          cta2: {
            link: "/registered-agent",
            text: "Learn More",
            direct: true,
            type: "transparent-grey",
          },
        },
        {
          headline: "Create a Compliance Calendar or Get Compliance Guard",
          description:
            "We monitor compliance and handle your company filings so you don’t have to.",
          visible: this.formData.cg === false,
          cta1: {
            link: "/orders/create/compliance-guard",
            text: "Get Started",
            direct: true,
            type: "transparent-blue",
          },
          cta2: {
            link: "/compliance-guard",
            text: "Learn More",
            direct: true,
            type: "transparent-grey",
          },
        },
        {
          headline: "Get a Tax ID (EIN)",
          description:
            "An EIN is required by the IRS for all businesses that pay taxes.",
          visible: this.formData.ein === false,
          cta1: {
            link: "/orders/create/employer-identification-number",
            text: "Get Started",
            direct: true,
            type: "transparent-blue",
          },
          cta2: {
            link:
              "/categories/business-services/employer-identification-number",
            text: "Learn More",
            direct: true,
            type: "transparent-grey",
          },
        },
        {
          headline: "Open a bank account",
          description: "Compare the best offers available on the market.",
          visible: this.formData.banking === false,
          cta1: {
            link: "/account/business-banking",
            text: "Compare the best banking offers",
            direct: true,
            type: "transparent-blue",
          },
        },
        {
          headline: "Create an online presence",
          description:
            "Having a logo and website enhances your new business's credibility, improves visibility, and helps attract and retain customers.",
          visible: this.formData.website === false,
          cta1: {
            link: "https://wix.pxf.io/c/2227905/2097976/25616?trafcat=logo",
            text: "Create a logo",
            direct: false,
            type: "transparent-blue",
          },
          cta2: {
            link: "https://wix.pxf.io/c/2227905/2097932/25616?trafcat=domain",
            text: "Create a website",
            direct: false,
            type: "transparent-blue",
          },
        },
      ];
    },
  },
  watch: {
    page(newValue) {
      if (newValue === "checklist-f" || newValue === "checklist-nof") {
        clarityEvent("Checklist Visible", {
          type: newValue,
        });
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
    },
  },
};
